module.exports = __webpack_public_path__ + "img/sy2.b97c52ba.png";